import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Modal } from 'antd';
const CertDeleteConfrim = (props) => {
    return (_jsx(Modal, { title: "Confirmation", open: props.open, width: 400, onCancel: props.onClose, onOk: props.handleDeleteCertificate, children: _jsx(_Fragment, { children: "Are you sure want to proceed?" }) }));
};
export default CertDeleteConfrim;
